var Config = {
   LIMIT: "10",
   PERSIST_SECRET_KEY: "dcscdscdscdsc",
   ENVIRONMENT: "DEMO",
   ENVIRONMENTS: {
      LOCAL: {
         API_URL: "https://demo-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://demo-configurator-tool.casita.kodefuse.com",
      },
      DEVELOPMENT: {
         API_URL: "https://demo-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://demo-configurator-tool.casita.kodefuse.com",
      },
      STAGING: {
         API_URL: "https://demo-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://demo-configurator-tool.casita.kodefuse.com",
      },
      DEMO: {
         API_URL: "https://demo-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://demo-configurator-tool.casita.kodefuse.com",
      },
      PRODUCTION: {
         API_URL: "https://demo-api.casita.kodefuse.com/v1",
         DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
         CONFIGURATOR_WEB_URL: "https://demo-configurator-tool.casita.kodefuse.com",
      },
   },
}

Config.env = () => {
   return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config